import React from 'react'
import swal from "sweetalert";
import VICDownloadModal from './VICDownloadModal'

import { DateInput } from "semantic-ui-calendar-react";
import moment from 'moment'
import { Icon, Menu, Popup, Message, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import colors from '../colors'
import { Segment, Sidebar } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { DateRange } from 'react-date-range';
import { MDBBtn } from 'mdbreact'
// import colors from '../colors'
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import calendar from "./calendar.ico";
export default class VICTable extends React.Component {
  constructor(props) {
    super(props)
    console.log(props.date)
    this.state = {
      modal: false,
      date: null,
      activeIndex: 0,
      // selectionRange:
      // {

      //     startDate: new Date(props.vicstart_date),
      //     endDate: new Date(props.etend_date),
      //   key: 'selection'

      // },
      date1: null,
      date2: null
    }
  }




  handleDownload = async () => {
    this.props.handleSubmitDisable()
    this.setState({
      modal: true
    })
    // if (window.sessionStorage.getItem("loginUser") !== null) {
     
    // }
    // else {
    //   swal({
    //     title: `Message`,

    //     padding: "3em",

    //     text:
    //       " Please Login",
    //   });

    //   //   try {
    //   //     cas.redirect();
    //   //     let result=await cas.getLogin()
    //   //     console.log(result)
    //   //   } catch (err) {
    //   //     if (err.error !== "login_required") console.log("error: " + err);
    //   //   }
    //   // }
    // }
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }
  render() {
    let vicproducts,enabledDates_vic;
    // enabledDates_vic = this.props.vicdates.map((momentDate) => momentDate.toDate());

    console.log(this.props.vicproducts)
    if (this.props.vicproducts !== null) {
      vicproducts = this.props.vicproducts.map((product) => {
        // if(product!=='Evapotranspiration')
        return (<option value={product}>{product}</option>)
      })

    }


    return (
      <div>
        {this.state.modal ? <VICDownloadModal modal={this.state.modal} title="Hydrological Products (Surface Runoff, Soil Moisture)" toggle={this.toggle} d1={this.props.d1} d2={this.props.d2}
         theme="VIC" product={this.props.vicselectedproduct} user={window.sessionStorage.getItem("loginUser")} /> : null}


        <div className="wrapper_data">
          <div id="one">

            Select Product
                    <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleVICProductChange}
              value={this.props.vicselectedproduct}
              selected={this.props.vicselectedproduct}
            >
              <option value="#">Select</option>
              {vicproducts}

            </select>
          </div>
          <div id="two">
            Availability {this.props.vicstart_date !== null ?
              <p style={{ color: "blue" }}> {moment(this.props.vicstart_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} - {moment(this.props.vicend_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} </p> : null}

          </div>
        </div>


        {this.props.selectionRange !== null && this.props.vicend_date !== null ?
          <div className="wrapper_data">
            <div id="one">


              Date Range Selection
                <br />  
                 <DateRange

                ranges={[this.props.selectionRange]}
                onChange={this.props.handleSelect}
                moveRangeOnFirstSelection={false}
                minDate={new Date(this.props.vicstart_date)}
                maxDate={new Date(this.props.vicend_date)}

                dayContentRenderer={(date) => {
                  const enabledDates_vic = this.props.vicdates.map((momentDate) => momentDate.toDate());
              
                  const isAvailable = enabledDates_vic.some(
                    (enabledDate) =>
                      enabledDate.toISOString().split("T")[0] === date.toISOString().split("T")[0]
                  );
                  return (
                    <div
                      style={{
                        backgroundColor: isAvailable ? "#90EE90" : "transparent", // Light green for available dates
                         borderRadius: "50%",
                         color:"black",
                        // paddingTop: "10px",
                        // paddingLeft:"10px",
                        // paddingRight:"10px",
                        // paddingBottom:"-10px",
                        padding:"10px",


                        textAlign:"center",
                      }}
                    >
                      {date.getDate()}
                    </div>
                  );
                }}
              
              />
               <br />

            </div>
            <div id="two">
              {this.props.date1 !== null ? <Message size='small'>Selected Dates:&nbsp;{
                moment(this.props.date1, "DD-MM-YYYY").format(
                  "DD-MMM-YYYY")} - {moment(this.props.date2, "DD-MM-YYYY").format(
                    "DD-MMM-YYYY")}
              </Message> : null}
              {!this.props.submitdisable ?
                <button
                  onClick={this.handleDownload}


                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
                : null}
              {/* <Message warning>* Maximum downloadable products are 10 at a time.</Message> */}



            </div>


          </div> : null}



        {/*               
               <Button animated>
                    <Link to="/webgis-vic/map">   <Button.Content visible>Geoportal</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Link>
                </Button>
               */}



        {/* <table
            className="table table-bordered"
            
          
            style={{backgroundColor:"white",tableLayout:"fixed",width:"100%"}}
          >
          
            <thead style={{ textAlign: "center", backgroundColor: colors["sidebar-sub-menu"] }}>
              <tr>
                <th scope="col">S. No</th>
               
             
                <th scope="col">Product</th>
                <th scope="col">Availability</th>
                <th scope="col">Date Range Selection </th>
                <th scope="col">Selected Range </th>
                <th scope="col">Download</th>
                
              </tr>
            </thead>
          <tbody>
            <td> 1</td> */}

        {/* <td> Energy Balance </td>
            <td> From 01 - Jan -2019 </td>
            <td> */}
        {/* <Popup
                    position="top right"
                    trigger={
                      <img
                        src={calendar}
                        width="20"
                        height="20"
                        align="right"
                        alt="calendar"
                      ></img>
                    }
                    on="click"
                  >

 <DateInput
                      // inline
                      name="date"
                      inline
                      value={moment(this.state.date, "DD-MM-YYYY").format(
                        "DD-MM-YYYY"
                      )}
                      onChange={this.handleDateChange}
                      dateFormat="DD-MM-YYYY"
                      markColor="orange"
                      placeholder="Date"
                      iconPosition="left"
                      closable={false}
                      initialDate={this.props.date}
                     // value={this.state.date}
                      closeOnMouseLeave
                      enable={this.props.availableDates}
                      marked={this.props.availableDates}
                      startMode="day"
                      pickerWidth="200px"
                      popupPosition="top right"
                      clearIcon={<Icon name="remove" color="red" />}
                    />
   </Popup> */}


        {/* </td>
            {this.state.date1!==null?<td>{moment(this.state.date1, "DD-MM-YYYY").format(
                            "DD-MMM-YYYY")} - {moment(this.state.date2, "DD-MM-YYYY").format(
                              "DD-MMM-YYYY")} </td>:<td>-</td>}
            {this.state.date1!==null?<td><Button className="btn-sm" rounded color="yellow" onClick={this.handleDownload}>Download</Button></td>:null}
          
          </tbody>
          </table>  */}


      </div>

    )
  }
}



